export default __webpack_public_path__ + "images/U6.82150ef.png";